import multiData from './MediatorsComponents/multiData';
import dataPoly from './MediatorsComponents/dataPoly';
import { useCommonPageSubscribers } from './MediatorsComponents/driveBuilderMultiTourAllPartsSubscribers';
import { trigger } from './MediatorsComponents/trigger';

import allPartsOnPage from './allTourPages';
/*
 *   TourBuilder is a mediator;
 *   action need for work with Redux store;
 *   PartData function return tour data object only for one part;
 *   useCommonPageSubscribers listen all other app objects events;
 *   trigger is generate events for oter app objects;
 *   history is saving each unicume tour state;
 */
const initAllTourPages = (actions) => {
  return new allPartsOnPage(
    actions,
    multiData(),
    dataPoly(),
    useCommonPageSubscribers,
    trigger()
  );
};

export default initAllTourPages;
